import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import type { GraphSettings, UpdateGraphSettingsInput } from '@catalyst-psa/shared';

import { api } from '../../api/client.js';

const graphKeys = {
  settings: ['graph', 'settings'] as const,
};

export function useGraphSettings(): UseQueryResult<GraphSettings> {
  return useQuery({
    queryKey: graphKeys.settings,
    queryFn: () => api.get<GraphSettings>('/graph/settings'),
  });
}

export function useUpdateGraphSettings(): UseMutationResult<
  GraphSettings,
  unknown,
  UpdateGraphSettingsInput
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateGraphSettingsInput) =>
      api.put<GraphSettings>('/graph/settings', input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: graphKeys.settings });
    },
  });
}
